<div class="full-height layout-row layout-align-start-center">


  <div class="flex form-group">
    <label translate>Hours</label>
    <input type="number"
           class="flex form-control input"
           min="0"
           step="1"
           [placeholder]="'Hours' | translate"
           [disabled]="disabled"
           [ngModel]="hours"
           [appBringozIdGenerator]="hoursTestId"
           (keydown)="blockNonIntegers($event)"
           (input)="onHoursChange($event.target.value)"
           (change)="onHoursChange($event.target.value)"/>
  </div>

  <div class="flex form-group">
    <label translate>Minutes</label>
    <input type="number"
           class="flex form-control input"
           min="0"
           max="59"
           step="1"
           [placeholder]="'Minutes' | translate"
           [disabled]="disabled"
           [ngModel]="minutes"
           [appBringozIdGenerator]="minutesTestId"
           (keydown)="blockNonIntegers($event)"
           (input)="onMinutesChange($event.target.value)"
           (change)="onMinutesChange($event.target.value)"/>
  </div>

<!--  <input-->
<!--    type="number"-->
<!--    class="flex form-control"-->
<!--    min="0"-->
<!--    placeholder="Hours"-->
<!--    [ngModel]="hours"-->
<!--    (ngModelChange)="onHoursChange($event)"-->
<!--    [attr.disabled]="disabled ? '' : null"-->
<!--  />-->

<!--  <input-->
<!--    type="number"-->
<!--    class="flex form-control"-->
<!--    min="0"-->
<!--    placeholder="Minutes"-->
<!--    [ngModel]="minutes"-->
<!--    (ngModelChange)="onMinutesChange($event)"-->
<!--    [attr.disabled]="disabled ? '' : null"-->
<!--  />-->

</div>
